function initQuickViewSwiper() {
  if (typeof Swiper === "undefined") return;

  const swiperMain = document.querySelector("[data-main-pdp-swiper]");
  if (!swiperMain) return;

  let options = {};
  try {
    options = JSON.parse(swiperMain.getAttribute("data-slider-options"));
  } catch (e) {
    console.error("Invalid Swiper JSON", e);
  }

  new Swiper(swiperMain, options);
}


document.addEventListener("click", async function(e) {
  const opener = e.target.closest("modal-opener");
  if (!opener) return;

  const handle = opener.dataset.handle;
  const container = document.querySelector("#QuickViewContainer");

  const response = await fetch(`/products/${handle}?view=quick-view`);
  const html = await response.text();
  container.innerHTML = html;

  container.classList.add("open");

  initQuickViewSwiper();
});


document.addEventListener("click", function (e) {
  const exitBtn = e.target.closest(".exit-quick-view");
  if (!exitBtn) return;

  const containers = document.querySelectorAll("#QuickViewContainer");

  if (containers.length) {
    containers.forEach(container => {
      if (container.classList.contains("open")) {
        container.classList.remove("open");
        container.innerHTML = "";
      }
    });
  }
});
